import { z } from 'zod';
import { ApiSuccessResponseSchema } from './api';

/**
 * Identity Verification Schemas
 * 
 * Epic 2 - Story 2.3: Runtime Type Safety
 * 
 * These schemas validate identity verification operations.
 */

/**
 * Trigger Validate Identity Response
 */
export const TriggerValidateIdentityResponseSchema = ApiSuccessResponseSchema(
  z.object({
    session_id: z.string(),
    challenge_id: z.string().nullable().optional(),
    status: z.string().nullable().optional(),
    next: z.string().nullable().optional(),
    expiresAt: z.string().nullable().optional(),
  })
);

export type TriggerValidateIdentityResponse = z.infer<
  typeof TriggerValidateIdentityResponseSchema
>;

/**
 * Check ID Verify Status Response
 */
export const CheckIdVerifyStatusResponseSchema = ApiSuccessResponseSchema(
  z.object({
    session_id: z.string().optional(),
    user_id: z.string().optional(),
    challenge_result: z.string().optional(),
    challenge_value: z.string().nullable().optional(),
    next: z.string().nullable().optional(),
  })
);

export type CheckIdVerifyStatusResponse = z.infer<
  typeof CheckIdVerifyStatusResponseSchema
>;

